import StoreService, { UPDATE_ONE } from '@topgeschenken/front-library/services/StoreService';
import paths from '~/constants/paths';

const BASE_ENDPOINT = '/relation/customers';
const storeService = new StoreService(BASE_ENDPOINT);

const state = () => ({
  ...storeService.getState(),
});

/**
 * Todo: merge into customer store (and user getter/filters to get company customers)
 */
const actions = {
  ...storeService.getActions(),

  updateCompanyRoles ({ commit }, { customer, companyRoles }) {
    if (state.selectedUser === null) {
      return;
    }

    this.$getDataProvider(paths.customers)
      .update('', {
        uuid: customer.uuid,
        action: 'company-roles',
        data: companyRoles,
      })
      .then((response) => {
        return commit(UPDATE_ONE, response.data);
      });
  },
};

const mutations = {
  ...storeService.getMutations(),
};

const getters = {
  ...storeService.getGetters(),
};

export default {
  state,
  actions,
  mutations,
  getters,
};
